import { FiltersAction, FiltersActionTypes, FiltersState } from '../types';
import { FILTER_GLOBAL_KEYS } from '../../config/constants';

export default (state: FiltersState = {}, action: FiltersActionTypes) => {
  const newState = { ...state };
  switch (action.type) {
    case FiltersAction.CHANGE_SELECTED_FILTERS_PROPERTY:
      if (!newState[action.scope]) {
        newState[action.scope] = {};
      }
      newState[action.scope][action.filterKey] = action.property;
      return newState;
    case FiltersAction.REPLACE_TEAMS_LIST:
      newState[FILTER_GLOBAL_KEYS.TEAMS] = { ...action.teamsGroups };
      return newState;
    case FiltersAction.REPLACE_ALL_SEASON_WEEKS:
      newState[FILTER_GLOBAL_KEYS.WEEKS] = { ...action.weeks };
      return newState;
    case FiltersAction.REPLACE_VENUES:
      newState[FILTER_GLOBAL_KEYS.VENUES] = { ...action.venues };
      return newState;
    case FiltersAction.UPDATE_PRACTICES_DATE_RANGE_SELECTOR:
      if (!newState[FILTER_GLOBAL_KEYS.PRACTICES_DATE_RANGE_SELECTOR]) {
        newState[FILTER_GLOBAL_KEYS.PRACTICES_DATE_RANGE_SELECTOR] = {};
      }
      if (!newState[FILTER_GLOBAL_KEYS.PRACTICES_DATE_RANGE_SELECTOR]![action.teamId]) {
        newState[FILTER_GLOBAL_KEYS.PRACTICES_DATE_RANGE_SELECTOR]![action.teamId] = {};
      }
      newState[FILTER_GLOBAL_KEYS.PRACTICES_DATE_RANGE_SELECTOR]![action.teamId][action.yearSeason] = action.dataPractices;
      return newState;
    default:
      return state;
  }
};
